function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { memo, useContext } from 'react';
import Text from '../Text';
import { FormGroupContext } from './FormGroup';
const Label = /*#__PURE__*/memo(_ref => {
  let {
    as = 'label',
    fontWeight = 'bold',
    ...props
  } = _ref;
  const id = useContext(FormGroupContext);
  return /*#__PURE__*/React.createElement(Text, _extends({
    as: as,
    fontWeight: fontWeight,
    htmlFor: id
  }, props));
});
Label.propTypes = {};
Label.displayName = 'Label';
export default Label;